import { useCentrixApi } from "core/hooks/useCentrixApi";
import { useLocale } from "core/hooks/useLocale";
import type { components } from "resources/api-schema";

type NewsEventType = Extract<
  components["schemas"]["Fixnetwork.NewsEvents.Categories.NewsEventAggregation"],
  "newstype" | "eventtype"
>;

export function useNewsEventsTypes(type: NewsEventType) {
  const locale = useLocale();
  return useCentrixApi({
    path: "/api/news-events/categories/CategoriesSummaries",
    parameters: {
      query: {
        Aggregation: type,
        Locale: locale,
      },
    },
  });
}
